<template>
    <div class="hot-question-wrapper">
        <HotQuestCard
            v-for="(hotCard, idx) in data.content"
            :key="hotCard.uId"
            :data="data.content[idx]"
            @deleteCard="deleteCard"
            @tranferCard="tranferCard"
        />
        <AddHot @addClick="addHotCard" />
    </div>
</template>

<script>
import HotQuestCard from "./hotItem/HotQuestCard.vue";
import AddHot from "./hotItem/AddHot.vue";
import { uniqueId, genIndexSearchHandler } from "@/views/zhiji/js/common/util.js";

export default {
    name: "HotRecommend",
    props: ["data"],
    components: {
        HotQuestCard,
        AddHot
    },
    data() {
        return {
            hotCardData: this.data
        };
    },
    model: {
        prop: "data",
        event: "update"
    },
    methods: {
        // 初始化一个热点卡片数据
        initHotCardData() {
            return {
                uId: uniqueId(),
                items: Array(2)
                    .fill(uniqueId())
                    .map(() => ({
                        uId: uniqueId(),
                        hotTitle: "",
                        questionId: "",
                        question: "",
                        wtType: "HotEditItem"
                    }))
            };
        },
        // 新增热点卡片
        addHotCard() {
            this.hotCardData.content.push(this.initHotCardData());
            this.$emit("update", this.hotCardData);
        },
        // 删除热点卡片
        deleteCard(cardData) {
            const itemIdx = genIndexSearchHandler("uId")(this.hotCardData.content, cardData.uId);
            this.hotCardData.content.splice(itemIdx, 1);
        },
        // 拖拽热点卡片
        tranferCard(newIdx, cardData) {
            const itemIdx = genIndexSearchHandler("uId")(this.hotCardData.content, cardData.uId);

            if (newIdx < 0 || newIdx === itemIdx) {
                return;
            }

            const item = this.hotCardData.content[itemIdx];
            this.hotCardData.content.splice(itemIdx, 1);
            this.hotCardData.content.splice(newIdx, 0, item);
        }
    }
};
</script>

<style lang="less" scoped>
.hot-question-wrapper {
    position: relative;
    display: flex;
}
</style>
